import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { BaseApi } from 'src/backend/api/base-api';
@Component({
    selector: 'btn-cell-rendererAuditTaskTracker',
    template: `
            <!-- <button *ngIf="params.node.data.userId === loggedUser?.UserId && params.node.data.Status === 'NEW'" mat-mini-fab color="accent" style="background: #74ff9e;" (click)="onClick($event)">
                <mat-icon>playlist_add_check</mat-icon>
            </button> -->
            <button *ngIf="params.data" mat-mini-fab color="accent" pTooltip="View" tooltipPosition="top" style="background: #3f38c8;"  (click)="onClick($event)">
            <mat-icon>remove_red_eye</mat-icon>
         </button>
  `
})
export class BtnRendererAuditTaskTracker implements ICellRendererAngularComp, OnDestroy {
    params: any;
    loggedUser: any;
    constructor(private baseApi: BaseApi,){}
    refresh(params: any): boolean {
        throw new Error('Method not implemented.');
    }
    agInit(params: any): void {
        // this.loggedUser = JSON.parse(localStorage.getItem('user'));
        //this.loggedUser = this.baseApi.getUserSession();
        this.params = params;
    }
    onClick($event: any): any {

        if (this.params.onClick instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            };
            this.params.onClick(params);
        }
    }
    ngOnDestroy(): any {

    }
}